import { observer } from 'mobx-react-lite';
import { useEffect, SyntheticEvent } from 'react';
import { Button, Dropdown, Grid } from 'semantic-ui-react';
import WorkLevelMasterModal from '../../../app/common/modals/WorkLevelMasterModal';
import { store, useStore } from '../../../app/stores/store';
import { useState } from 'react';
import { WorkLevel } from './../../../app/models/workLevel';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';

interface Props {
  isFilmFestival: boolean;
}

function DashboardWorkLevel({ isFilmFestival }: Props) {
  const { dashboardStore, WorkLevelStore, commonStore, userStore } = useStore();
  const {
    loadWorkLevels,
    workLevelRegistryAll,
    workLevelitemsByDateAll,
    loadWorkLevel,
  } = WorkLevelStore;
  const [intialSearch, setInitialSearch] = useState<string>('');
  // to load all existing vaults
  useEffect(() => {
    if (workLevelRegistryAll.size <= 1) loadWorkLevels();
  }, [workLevelRegistryAll.size, loadWorkLevels]);

  useEffect(() => {
    if (isFilmFestival) {
      const selectedData = workLevelitemsByDateAll.filter((x) => {
        return x.title === 'Film Festival' ? x : '';
      });
      if (selectedData.length > 0) {
        setInitialSearch(selectedData[0].title);
        loadWorkLevel(selectedData[0].id);
        WorkLevelStore.selectedworkLevel = selectedData[0];
        dashboardStore.setWorkLevelMaster(selectedData[0]);
      }
    }
    // eslint-disable-next-line
  }, [isFilmFestival]);

  useEffect(() => {
    const selectedData = workLevelitemsByDateAll.filter((x) => {
      return x.title === dashboardStore.dashboard.checkClikedWorkLevel.title
        ? x
        : '';
    });
    if (selectedData.length !== 0) {
      setInitialSearch(selectedData[0].title);
      loadWorkLevel(selectedData[0].id);
      dashboardStore.setWorkLevelMaster(selectedData[0]);
    } else {
      setInitialSearch('');
    }
    // eslint-disable-next-line
  }, [dashboardStore.dashboard.checkClikedWorkLevel.title]);

  const workleveloptions = workLevelitemsByDateAll.map((x) => ({
    key: x.id,
    text: x.title,
    value: x.id,
  }));
  const handleDropDownSelect = (e: SyntheticEvent, data: any) => {
    if (data.value === '') {
      setInitialSearch('');
      loadWorkLevel(data.value);
      store.WorkLevelStore.selectedworkLevel = undefined;
    } else {
      const datas: WorkLevel | undefined = workLevelRegistryAll.get(data.value);
      if (datas !== undefined) {
        store.WorkLevelStore.selectedworkLevel = datas;
        dashboardStore.setWorkLevelMaster(datas);
        setInitialSearch(datas?.title!);
      }
    }
  };

  return (
    <div>
      {dashboardStore.dashboard.openWorkLevelMasterModal ? (
        <WorkLevelMasterModal />
      ) : null}
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column width={15}>
            <p style={{ marginLeft: '10px', marginBottom: '5px' }}>
              <b //WorkLevel
              >
                {userStore?.user?.customerName === 'RAI' ||
                commonStore.hfcCustomerChanges
                  ? 'Title'
                  : (
                      userLanguage[0].Level3InventoryRecievingVerify
                        ?.IRVL02 as any
                    )?.[`${commonStore.language.key}`]}
              </b>
            </p>
            {!isFilmFestival && (
              <Dropdown
                clearable
                fluid
                search
                selection
                options={workleveloptions}
                // searchQuery={initialSearch}

                placeholder={
                  userStore?.user?.customerName === 'RAI'
                    ? 'Select/Create Title'
                    : (
                        userLanguage[0].Level3InventoryRecievingVerify
                          ?.IRVDD01 as any
                      )?.[`${commonStore.language.key}`]
                } //"Select/Create WorkLevel"
                onChange={handleDropDownSelect}
                // value={initialSearch}
              />
            )}
            {isFilmFestival && <input type="text" value={intialSearch} />}
          </Grid.Column>
          <Grid.Column width={1}>
            {!isFilmFestival && (
              <Button
                style={{
                  borderRadius: '30px',
                  marginTop: '28px',
                }}
                onClick={() => dashboardStore.setOpenWorkLevelMasterModal(true)}
                positive
                size="mini"
                icon="plus"
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
}

export default observer(DashboardWorkLevel);
